import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage,
  LifeSaverForm,
  ScreenHeader, TextArea
} from '../../components';
import { useCreateOrUpdate, useFormData } from '../../hooks';

import { NewFAContext } from '.';

const formConfig = {
  fields: [
    { 
      id: 'obituary-details', 
      fieldName: 'obituary_details',
      type: 'text' as const,
      required: true 
    }
  ]
};


export function NewFAObituaryDetails() {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleCreateOrUpdate } = useCreateOrUpdate('funeral_arrangements');
  const { handleData, errors } = useFormData(formConfig);
    
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const formData = handleData();
    
    // Validate required fields
    if (!formData.obituary_details) {
      return;
    }

    const payload = {
      ...formData,
      user_id: funeralArrangement?.user_id || null,
      person_id: funeralArrangement?.person_id || null
    };

    try {
      await handleCreateOrUpdate(funeralArrangement?.id || '', payload);
      await update();
      navigate('../financial-planning');
    } catch (err) {
      console.error('Error saving obituary details:', err);
    }
  }, [ navigate, funeralArrangement, handleCreateOrUpdate, update, handleData ]);

  return (
    <div className="new-fa-disposition screen">
      <ScreenHeader 
        title="Obituary Details"
        description="Specify your obituary details."
        steps={6}
        step={1}
        handleBack={handleBack}
      />

      <LifeSaverForm 
        icon="edit_note"
        header="Obituary Details"
      >
        <TextArea
          id="obituary-details"
          name="obituary_details"
          label="Obituary Details"
          placeholder="Enter details for your obituary..."
          style={{ maxWidth: '100%' }}
          required
        />
      </LifeSaverForm>

      <ErrorMessage message={errors[0]} />
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}